import { render, staticRenderFns } from "./TargetsModal.vue?vue&type=template&id=2634f390&scoped=true"
import script from "./TargetsModal.vue?vue&type=script&lang=js"
export * from "./TargetsModal.vue?vue&type=script&lang=js"
import style0 from "./TargetsModal.vue?vue&type=style&index=0&id=2634f390&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2634f390",
  null
  
)

export default component.exports